import React, { useRef, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import gsap from "gsap"
import styled from "styled-components"
import Img from "gatsby-image"
import { ScrollTrigger } from "gsap/ScrollTrigger"

import VideoHR from "./../../images/videos/biodiversity_HR.mp4"
import VideoLR from "./../../images/videos/biodiversity_LR.mp4"

import Title from "./../Title"

const SectionCare = ({ data }) => {
    const INSECT_SECTION_WRAPPER = useRef(null)
    const INSECT_SECTION_TEXT = useRef(null)
    const INSECT_SECTION_IMAGE = useRef(null)

    const { insect } = useStaticQuery(graphql`
        query {
            insect: allFile(
                filter: {
                    relativePath: { in: ["home/images/section-insect.jpg"] }
                }
            ) {
                edges {
                    node {
                        name
                        publicURL
                        childImageSharp {
                            fluid(maxWidth: 800) {
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
            }
        }
    `)

    const timeline = () =>
        gsap
            .timeline({
                scrollTrigger: {
                    trigger: INSECT_SECTION_WRAPPER.current,
                    start: "top top",
                    end: () => "+=150%",
                    scrub: true,
                    pin: true,
                    pinSpacing: false,
                    anticipatePin: 1,
                },
            })
            .set(INSECT_SECTION_IMAGE.current, {
                xPercent: "100",
            })
            .set(INSECT_SECTION_TEXT.current, {
                yPercent: "10",
            })
            .to(INSECT_SECTION_TEXT.current, {
                autoAlpha: 1,
                yPercent: "0",
                duration: "0.5",
            })
            .to(INSECT_SECTION_IMAGE.current, {
                xPercent: "0",
                duration: "1",
            })
            .to(
                INSECT_SECTION_IMAGE.current,
                {
                    autoAlpha: "1",
                    duration: "0.3",
                },
                "-=1"
            )
            .set(INSECT_SECTION_TEXT.current, {
                autoAlpha: 0,
            })
            .to(INSECT_SECTION_IMAGE.current, {
                xPercent: "-150",
                autoAlpha: 0,
                duration: "1",
            })
            .to(
                INSECT_SECTION_TEXT.current,
                {
                    autoAlpha: 0,
                },
                "-=0.5"
            )

    useEffect(() => {
        if (typeof window !== "undefined") {
            gsap.registerPlugin(ScrollTrigger)
        }

        gsap.defaults({
            ease: "none",
        })

        ScrollTrigger.matchMedia({
            "(min-width: 1025px)": function() {
                timeline()
            },
        })
    }, [])

    return (
        <section className="section-insect">
            <div className="is-mobile">
                <div className="mobile-video">
                    <video
                        className="full-video"
                        autoPlay
                        playsInline
                        muted
                        loop
                        style={{
                            width: "100%",
                            height: "100%",
                            minWidth: "100%",
                            minHeight: "100%",
                        }}
                    >
                        <source src={VideoLR} type="video/mp4" />
                    </video>
                </div>
                <div className="section-insect__wrapper">
                    <Title
                        title={data.title}
                        description={data.description}
                        alignment="left"
                        header
                        text
                    />
                </div>
            </div>
            <div
                ref={INSECT_SECTION_WRAPPER}
                className="section-insect__wrapper is-desktop"
            >
                <div ref={INSECT_SECTION_TEXT} className="section-insect__text">
                    <Title
                        title={data.title}
                        description={data.description}
                        alignment="left"
                        header
                        text
                    />
                </div>
                <div
                    ref={INSECT_SECTION_IMAGE}
                    className="section-insect__decor"
                >
                    <div className="picture-image picture-image__full picture-care">
                        <video
                            className="full-video"
                            autoPlay
                            playsInline
                            muted
                            loop
                            style={{
                                width: "100%",
                                height: "100%",
                                minWidth: "100%",
                                minHeight: "100%",
                            }}
                        >
                            <source src={VideoHR} type="video/mp4" />
                        </video>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SectionCare
